import React, { Component } from 'react';
import Header from '../../Layouts/Header'
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import AuthApi from '../../Services/Authapi';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TableComponent from '../../Layouts/TableComponent';
import swal from 'sweetalert';
import TextField from "@material-ui/core/TextField";
import AuthCheckComponent from '../../Layouts/Token';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import ls from "local-storage";
import { convertFromRaw, ContentState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from "@material-ui/icons/Close";
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
// Menu import removed because it's no longer used
import { Select } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';

// Removed ReadMore component as description is no longer shown in the table

class Taskslist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tasks: [],
            count: 0,
            searchQuery: "",
            pageStatus: false,
            suggestions: [],
            expandedProfiles: {},
            selectedTaskDetails: null,
            showTaskDetailsPopup: false,
            tableTh: [
                { id: 'project_task_id', numeric: false, disablePadding: true, label: 'Task ID', sortable: true },
                { id: 'task', numeric: false, disablePadding: true, label: 'Task', sortable: true },
                { id: 'project_name', numeric: false, disablePadding: true, label: 'Project Name', sortable: true },
                { id: 'developer_name', numeric: false, disablePadding: true, label: 'Developer Name', sortable: true },
                { id: 'task_date_time', numeric: false, disablePadding: true, label: 'Task Deadline Date Time', sortable: true },
                { id: 'task_deliver_date', numeric: false, disablePadding: true, label: 'Task Deliver Date & Time', sortable: true },
                { id: 'description', numeric: false, disablePadding: true, label: 'Description', sortable: true },
                { id: 'assign_by', numeric: false, disablePadding: true, label: 'Assign By', sortable: true },
                { id: 'status', numeric: false, disablePadding: true, label: 'Status', sortable: true },
                { id: 'sub_tasks_count', numeric: false, disablePadding: true, label: 'Sub-Tasks Count', sortable: true },
                { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false }
            ],
            showStatusDropdown: false,
            showSubTasks: false,
            subTaskEditMode: {},
            activityLogs: [],
            showActivityLogs: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
        this.toggleProfileExpansion = this.toggleProfileExpansion.bind(this);
        this.handleDeleteTask = this.handleDeleteTask.bind(this);
        this.removeRow = this.removeRow.bind(this);
        this.handleViewTask = this.handleViewTask.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        // Removed menu handlers related to unused anchorEl/Menu
        this.handleStatusSelect = this.handleStatusSelect.bind(this);
        this.toggleStatusDropdown = this.toggleStatusDropdown.bind(this);
        this.toggleSubTasksVisibility = this.toggleSubTasksVisibility.bind(this);
        this.handleSubTaskStatusChange = this.handleSubTaskStatusChange.bind(this);
        this.toggleSubTaskEditMode = this.toggleSubTaskEditMode.bind(this);
        this.handleSubTaskStatusSelect = this.handleSubTaskStatusSelect.bind(this);
        this.toggleActivityLogsVisibility = this.toggleActivityLogsVisibility.bind(this);
    }

    async componentDidMount() {
        if (this.props && this.props.authToken === false) {
            // this.props.history.push('/login');
        }
        await this.fetchTasks();

        // Check for taskId only if it exists in the state
        const { state } = this.props.location;
        if (state && state.taskId) {
            this.openTaskFromNotification(state.taskId);
        }

        // Clear the taskId from the state after checking
        if (state && state.taskId) {
            this.props.history.replace({
                pathname: this.props.location.pathname,
                state: {}
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.tasks !== this.state.tasks) {
            this.checkForTaskId();
        }
    }

    checkForTaskId() {
        const { state } = this.props.location;
        console.log("Received state:", state);
        if (state && state.taskId) {
            const task = this.state.tasks.find(task => task.id === state.taskId);
            console.log("Found task:", task);
            if (task) {
                this.handleViewTask(task);
            }
        }
    }

    componentWillReceiveProps(props) {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    }

    handleChange(e) {
        const searchQuery = e.target.value.toLowerCase();
        const suggestions = this.state.tasks.filter((task) => {
            return (
                (task.task && task.task.toLowerCase().includes(searchQuery)) ||
                (task.developer_name && task.developer_name.toLowerCase().includes(searchQuery)) ||
                (task.assign_by && task.assign_by.toLowerCase().includes(searchQuery)) ||
                (task.project_name && task.project_name.toLowerCase().includes(searchQuery)) ||
                (task.description && task.description.toLowerCase().includes(searchQuery)) ||
                (task.task_date_time && (
                    this.formatDateTime(task.task_date_time).replace(/\s+/g, '').toLowerCase().includes(searchQuery.replace(/\s+/g, '').toLowerCase()) ||
                    task.task_date_time.replace(/\s+/g, '').toLowerCase().includes(searchQuery.replace(/\s+/g, '').toLowerCase())
                )) ||
                (task.task_deliver_date && (
                    this.formatDateTime(task.task_deliver_date).replace(/\s+/g, '').toLowerCase().includes(searchQuery.replace(/\s+/g, '').toLowerCase()) ||
                    task.task_deliver_date.replace(/\s+/g, '').toLowerCase().includes(searchQuery.replace(/\s+/g, '').toLowerCase())
                )) ||

                (task.status && task.status.toLowerCase().includes(searchQuery))
            );
        }).map(task => ({
            task: task.task,
            developer_name: task.developer_name,
            assign_by: task.assign_by,
            project_name: task.project_name,
            description: task.description,
            task_date_time: task.task_date_time,
            task_deliver_date: task.task_deliver_date,
            status: task.status
        }));

        const uniqueSuggestions = [...new Set(suggestions.flatMap(Object.values))];

        this.setState({ searchQuery, suggestions: uniqueSuggestions });
    }

    handleSearch = () => {
        const { tasks, searchQuery } = this.state;
        if (!tasks) return;

        const filterUser = tasks.filter((task) => {
            return (
                (task.task && task.task.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (task.developer_name && task.developer_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (task.assign_by && task.assign_by.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (task.project_name && task.project_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (task.description && task.description.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (task.task_date_time && (
                    this.formatDateTime(task.task_date_time).replace(/\s+/g, '').toLowerCase().includes(searchQuery.replace(/\s+/g, '').toLowerCase()) ||
                    task.task_date_time.replace(/\s+/g, '').toLowerCase().includes(searchQuery.replace(/\s+/g, '').toLowerCase())
                )) ||
                (task.task_deliver_date && (
                    this.formatDateTime(task.task_deliver_date).replace(/\s+/g, '').toLowerCase().includes(searchQuery.replace(/\s+/g, '').toLowerCase()) ||
                    task.task_deliver_date.replace(/\s+/g, '').toLowerCase().includes(searchQuery.replace(/\s+/g, '').toLowerCase())
                )) ||
                (task.status && task.status.toLowerCase().includes(searchQuery.toLowerCase()))
            );
        });
        this.setState({ filterUser });
    };

    formatDateTime = (timestamp) => {
        try {
            if (!timestamp) return 'N/A';

            // Split the timestamp into date and time parts
            const [datePart, timePart] = timestamp.split(' ');
            if (!datePart || !timePart) return 'Invalid Date Format';

            // Split date and time into components
            const [year, month, day] = datePart.split('-');
            const [hour, minute, second] = timePart.split(':');

            // Create date object (months are 0-based in JavaScript)
            const date = new Date(year, month - 1, day, hour, minute, second);

            if (isNaN(date.getTime())) return 'Invalid Date';

            // Format date as DD-MM-YYYY
            const formattedDate = `${day}-${month}-${year}`;

            // Format time as HH:MM AM/PM
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;
            const formattedMinutes = minutes.toString().padStart(2, '0');
            const formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;

            return `${formattedDate} ${formattedTime}`;
        } catch (error) {
            console.error("Error formatting date:", error);
            return 'N/A';
        }
    }

    clearSearch = () => {
        this.setState({ searchQuery: "", suggestions: [] }, this.handleSearch);
    };

    handleSuggestionClick = (suggestion) => {
        this.setState({ searchQuery: suggestion.jobTitle, suggestions: [] }, this.handleSearch);
    };

    toggleProfileExpansion(jobId) {
        this.setState((prevState) => ({
            expandedProfiles: {
                ...prevState.expandedProfiles,
                [jobId]: !prevState.expandedProfiles[jobId],
            },
        }));
    }

    async fetchTasks() {
        try {
            const isAdmin = ls("roles") === "Super Admin";
            const isEmployeeRole = ls("roles") === "Employee";
            let tasks = [];

            if (isAdmin) {
                tasks = await AuthApi.getTasks();
            } else if (isEmployeeRole) {
                tasks = await AuthApi.taskslistbyuserid();
            } else {
                tasks = await AuthApi.getTasks();
            }

            if (tasks && tasks.status) {
                this.setState({ tasks: tasks.data });
            } else {
                console.error("Failed to fetch tasks:", tasks.message);
            }
        } catch (error) {
            console.error("Error fetching tasks:", error);
        }
    }

    handleDeleteTask = async (taskId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this task?");
        if (!confirmDelete) return;

        try {
            const response = await AuthApi.deletetask(taskId);
            if (response) {
                swal("Success", "Task deleted successfully", "success");
                this.setState((prevState) => ({
                    tasks: prevState.tasks.filter(task => task.id !== taskId),
                    filterUser: prevState.filterUser ? prevState.filterUser.filter(task => task.id !== taskId) : null
                }));
            } else {
                swal("Error", "Failed to delete task", "error");
            }
        } catch (error) {
            console.error("Error deleting task:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    };

    async removeRow(taskId) {
        const confirmDelete = await swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this task!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        });

        if (!confirmDelete) return;

        try {
            const response = await AuthApi.deletetask(taskId);
            if (response) {
                swal("Success", "Task deleted successfully", "success");
                this.setState((prevState) => ({
                    tasks: prevState.tasks.filter(task => task.id !== taskId),
                    filterUser: prevState.filterUser ? prevState.filterUser.filter(task => task.id !== taskId) : null
                }));
            } else {
                swal("Error", "Failed to delete task", "error");
            }
        } catch (error) {
            console.error("Error deleting task:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    }

    async openTaskFromNotification(taskId) {
        try {
            const response = await AuthApi.taskgetbyid(taskId);
            console.log("API Response:", response);
            if (response && response.status === true) {
                const task = response.data;
                console.log("Task Data:", task);
                this.handleViewTask(task);
            } else {
                console.error("Failed to fetch task details:", response.message);
            }
        } catch (error) {
            console.error("Error fetching task details:", error);
        }
    }

    async handleViewTask(task) {
        let descriptionHTML = '';
        try {
            const contentState = task.description ? convertFromRaw(JSON.parse(task.description)) : ContentState.createFromText('');
            descriptionHTML = stateToHTML(contentState);
        } catch (error) {
            console.error("Error parsing description:", error);
            descriptionHTML = task.description;
        }

        // Parse and convert sub-tasks details to HTML
        let subTasksHTML = [];
        try {
            const subTasks = JSON.parse(task.sub_tasks);
            subTasksHTML = subTasks.map(subTask => {
                let subTaskDetailsHTML = '';
                try {
                    const subTaskContentState = subTask.details ? convertFromRaw(JSON.parse(subTask.details)) : ContentState.createFromText('');
                    subTaskDetailsHTML = stateToHTML(subTaskContentState);
                } catch (error) {
                    console.error("Error parsing sub-task details:", error);
                    subTaskDetailsHTML = subTask.details;
                }
                return { ...subTask, details: subTaskDetailsHTML };
            });
        } catch (error) {
            console.error("Error parsing sub-tasks:", error);
        }

        // Fetch activity logs
        const activityLogsResponse = await AuthApi.getActivityLogs(task.id);
        let activityLogs = [];

        if (activityLogsResponse.status && Array.isArray(activityLogsResponse.data)) {
            activityLogs = activityLogsResponse.data;
            // Sort logs by timestamp
            activityLogs.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
        }

        this.setState({
            selectedTaskDetails: {
                ...task,
                description: descriptionHTML,
                subTasks: subTasksHTML
            },
            activityLogs, // Set the sorted activity logs
            showTaskDetailsPopup: true
        });
    }

    handleStatusChange = async (taskId, newStatus) => {
        try {
            // Show loading message
            swal("Loading", "Updating task status...", "info", {
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
            });

            const response = await AuthApi.updateTaskStatus(taskId, newStatus);
            if (response && response.status) {
                swal("Success", "Task status updated successfully", "success");
                this.setState((prevState) => ({
                    tasks: prevState.tasks.map(task =>
                        task.id === taskId ? { ...task, status: newStatus } : task
                    ),
                    selectedTaskDetails: {
                        ...prevState.selectedTaskDetails,
                        status: newStatus
                    },
                    showTaskDetailsPopup: false
                }));
            } else {
                swal("Error", "Failed to update task status", "error");
            }
        } catch (error) {
            console.error("Error updating task status:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    };

    // Removed unused menu handlers

    toggleStatusDropdown = () => {
        this.setState((prevState) => ({ showStatusDropdown: !prevState.showStatusDropdown }));
    };

    handleStatusSelect = (event) => {
        const newStatus = event.target.value;
        this.setState((prevState) => ({
            selectedTaskDetails: {
                ...prevState.selectedTaskDetails,
                status: newStatus
            }
        }));
    };

    updateStatus = () => {
        const { selectedTaskDetails } = this.state;
        this.handleStatusChange(selectedTaskDetails.id, selectedTaskDetails.status);
        this.toggleStatusDropdown();
    };

    toggleSubTasksVisibility() {
        this.setState((prevState) => ({ showSubTasks: !prevState.showSubTasks }));
    }

    handleSubTaskStatusChange = async (taskId, subTaskName, newStatus) => {
        try {
            swal("Loading", "Updating sub-task status...", "info", {
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
            });

            console.log("Updating sub-task:", { taskId, subTaskName, newStatus });

            const response = await AuthApi.updateSubTaskStatus(taskId, subTaskName, newStatus);
            console.log("API Response:", response);

            if (response && response.status) {
                swal("Success", "Sub-task status updated successfully", "success");
                this.setState((prevState) => {
                    const updatedSubTasks = prevState.selectedTaskDetails.subTasks.map(subTask =>
                        subTask.name === subTaskName ? { ...subTask, status: newStatus } : subTask
                    );
                    return {
                        selectedTaskDetails: {
                            ...prevState.selectedTaskDetails,
                            subTasks: updatedSubTasks
                        }
                    };
                });
            } else {
                swal("Error", "Failed to update sub-task status", "error");
            }
        } catch (error) {
            console.error("Error updating sub-task status:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    };

    toggleSubTaskEditMode(subTaskName) {
        this.setState((prevState) => ({
            subTaskEditMode: {
                ...prevState.subTaskEditMode,
                [subTaskName]: !prevState.subTaskEditMode[subTaskName],
            },
        }));
    }

    handleSubTaskStatusSelect = (subTaskName, newStatus) => {
        this.setState((prevState) => {
            const updatedSubTasks = prevState.selectedTaskDetails.subTasks.map(subTask =>
                subTask.name === subTaskName ? { ...subTask, status: newStatus } : subTask
            );
            return {
                selectedTaskDetails: {
                    ...prevState.selectedTaskDetails,
                    subTasks: updatedSubTasks
                }
            };
        });
    };

    toggleActivityLogsVisibility = () => {
        this.setState((prevState) => ({
            showActivityLogs: !prevState.showActivityLogs,
        }));
    };

    getStatusColor = (status) => {
        switch ((status || '').toLowerCase()) {
            case 'done':
                return 'green';
            case 'pending':
                return 'red';
            case 'in progress':
                return 'orange';
            case 'need to discuss':
                return 'blue';
            case 'testing':
                return 'purple';
            default:
                return 'gray';
        }
    }

    render() {
        const classes = this.props;
        const { tasks, filterUser, suggestions, showTaskDetailsPopup, selectedTaskDetails, showStatusDropdown, showSubTasks } = this.state;
        const permissions = (this.props.authUser && Array.isArray(this.props.authUser.userAccess)) ? this.props.authUser.userAccess : [];
        const displayedTasks = filterUser || tasks;

        return (
            <div>
                <AuthCheckComponent authToken={this.props.authToken} />
                <Header
                    {...this.props}
                    authUser={this.props.authUser}
                    setAutUser={this.props.setAutUser}
                    component={
                        <div style={{ marginBottom: "11%" }}>
                            <Card className={classes.root} style={{ marginBottom: '3%' }}>
                                <CardContent>
                                    <Breadcrumb
                                        {...this.props}
                                        primaryPageName="Tasks"
                                        primaryPageLink="/tasks"
                                        isSecondaryPage={false}
                                        secondaryPageName="" />
                                </CardContent>
                            </Card>
                            <TextField
                                label="Search"
                                value={this.state.searchQuery}
                                onChange={this.handleChange}
                                style={{
                                    position: "absolute",
                                    right: "121px",
                                    marginTop: "21px"
                                }}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: this.state.searchQuery !== "",
                                    style: {
                                        color: '#1b6e95',
                                        transform: this.state.searchQuery !== "" ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                                        transition: 'transform 0.2s ease-in-out'
                                    }
                                }}
                                InputProps={{
                                    style: {
                                        backgroundColor: 'lightgray',
                                        borderRadius: '25px',
                                        height: "40px"
                                    },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {this.state.searchQuery && (
                                                <ClearIcon onClick={this.clearSearch} style={{ cursor: 'pointer' }} />
                                            )}
                                            <SearchIcon onClick={this.handleSearch} style={{ cursor: 'pointer' }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {this.state.searchQuery && suggestions.length > 0 && (
                                <Paper
                                    style={{
                                        position: 'absolute',
                                        right: '191px',
                                        marginTop: '62px',
                                        zIndex: 1,
                                        width: "207px",
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
                                    }}>
                                    {suggestions.map((suggestion, index) => (
                                        <MenuItem
                                            key={index}
                                            onClick={() => this.handleSuggestionClick({ jobTitle: suggestion })}
                                            style={{
                                                padding: '10px 20px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {suggestion}
                                        </MenuItem>
                                    ))}
                                </Paper>
                            )}
                            <TableComponent
                                {...this.props}
                                tableTh={[
                                    { id: 'project_task_id', numeric: false, disablePadding: true, label: 'Task ID', sortable: true },
                                    { id: 'task', numeric: false, disablePadding: true, label: 'Task', sortable: true },
                                    { id: 'project_name', numeric: false, disablePadding: true, label: 'Project Name', sortable: true },
                                    { id: 'developer_name', numeric: false, disablePadding: true, label: 'Developer Name', sortable: true },
                                    { id: 'task_date_time', numeric: false, disablePadding: true, label: 'Task Deadline Date Time', sortable: true },
                                    { id: 'task_deliver_date', numeric: false, disablePadding: true, label: 'Task Deliver Date & Time', sortable: true },
                                    { id: 'assign_by', numeric: false, disablePadding: true, label: 'Assign By', sortable: true },
                                    { id: 'status', numeric: false, disablePadding: true, label: 'Status', sortable: true },
                                    { id: 'sub_tasks_count', numeric: false, disablePadding: true, label: 'Sub-Tasks Count', sortable: true },
                                    { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false }
                                ]}
                                tableData={displayedTasks.map((task) => {
                                    // Format deliver date/time if present
                                    let formattedDeliverDate = task.task_deliver_date ? this.formatDateTime(task.task_deliver_date) : '';
                                    return {
                                        ...task,
                                        project_task_id: task.project_task_id,
                                        status: <span style={{
                                            color: this.getStatusColor(task.status),
                                            padding: '4px 10px',
                                            borderRadius: '12px',
                                            fontWeight: 'bold',
                                            display: 'inline-block',
                                            minWidth: '90px',
                                            textAlign: 'center'
                                        }}>{task.status}</span>,
                                        sub_tasks_count: task.sub_tasks_count,
                                        task_deliver_date: formattedDeliverDate,
                                        actions: (
                                            <div>
                                                <IconButton onClick={() => this.handleViewTask(task)} color="primary">
                                                    <VisibilityIcon />
                                                </IconButton>
                                                {/* Add other action buttons here if needed */}
                                            </div>
                                        ),
                                    };
                                })}
                                tableCount={displayedTasks.length}
                                tablePagestatus={this.state.pageStatus}
                                colNameToShow={['project_task_id', 'task', 'project_name', 'developer_name', 'task_date_time', 'task_deliver_date', 'assign_by', 'status', 'sub_tasks_count']}
                                openPopUp={false}
                                removeRow={this.removeRow}
                                actionBtns={[
                                    permissions.includes("Tasks.Edit") && 'update',
                                    permissions.includes("Tasks.Delete") && 'delete',
                                    'view'
                                ]}
                                modelName={'Tasks'}
                                addRoute={'/tasks/add'}
                                updateRoute={'/task/edit'}
                                openPopUpUpdate={false}
                                viewDetails={this.handleViewTask}
                            />

                            {showTaskDetailsPopup && selectedTaskDetails && (
                                <Dialog
                                    open={showTaskDetailsPopup}
                                    onClose={() => this.setState({ showTaskDetailsPopup: false })}
                                    maxWidth="lg"
                                    fullWidth
                                    PaperProps={{
                                        style: {
                                            borderRadius: "12px",
                                            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.2)",
                                            backgroundColor: "#f9f9f9",
                                            width: "750px",
                                        },
                                    }}
                                >
                                    <div style={{ position: "relative" }}>
                                        <DialogTitle
                                            style={{
                                                textAlign: "center",
                                                padding: "10px 0",
                                                backgroundColor: "#1b6e95",
                                                color: "#fff",
                                                borderTopLeftRadius: "12px",
                                                borderTopRightRadius: "12px",
                                                fontSize: "1.5rem",
                                            }}
                                        >
                                            Task Details
                                            <CloseIcon
                                                style={{
                                                    position: "absolute",
                                                    top: 10,
                                                    right: 10,
                                                    cursor: "pointer",
                                                    color: "#fff",
                                                    backgroundColor: "#f44336",
                                                    borderRadius: "50%",
                                                    padding: "2px",
                                                }}
                                                onClick={() => this.setState({ showTaskDetailsPopup: false })}
                                            />
                                        </DialogTitle>
                                        <DialogContent>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <div style={{ flex: 1, marginRight: "10px" }}>
                                                        <b>Task ID:</b> {selectedTaskDetails.project_task_id}
                                                    </div>
                                                    <div style={{ flex: 1, marginRight: "10px" }}>
                                                        <b>Task:</b> {selectedTaskDetails.task}
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <b>Project Name:</b> {selectedTaskDetails.project_name}
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <div style={{ flex: 1, marginRight: "10px" }}>
                                                        <b>Developer Name:</b> {selectedTaskDetails.developer_name}
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <b>Task Date Time:</b> {selectedTaskDetails.task_date_time}
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <b>Task Deliver Date & Time:</b> {selectedTaskDetails.task_deliver_date}
                                                    </div>
                                                </div>
                                                <div>
                                                    <b>Description:</b>
                                                    <div style={{ marginTop: "5px", padding: "10px", backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)" }}>
                                                        {selectedTaskDetails.description}
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <div style={{ flex: 1 }}>
                                                        <b>Assign By:</b> {selectedTaskDetails.assign_by}
                                                    </div>
                                                    <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                                                        <b>Status:</b>
                                                        {showStatusDropdown ? (
                                                            <>
                                                                <Select
                                                                    value={selectedTaskDetails.status}
                                                                    onChange={this.handleStatusSelect}
                                                                    style={{ marginLeft: "10px", marginRight: "10px" }}
                                                                >
                                                                    <MenuItem value="Done">Done</MenuItem>
                                                                    <MenuItem value="Pending">Pending</MenuItem>
                                                                    <MenuItem value="In Progress">In Progress</MenuItem>
                                                                    <MenuItem value="Need to Discuss">Need to Discuss</MenuItem>
                                                                    <MenuItem value="Testing">Testing</MenuItem>
                                                                </Select>
                                                                <IconButton onClick={this.toggleStatusDropdown} style={{ marginLeft: '5px' }}>
                                                                    <CloseIcon />
                                                                </IconButton>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <span style={{ marginLeft: "10px" }}>{selectedTaskDetails.status}</span>
                                                                <IconButton onClick={this.toggleStatusDropdown} style={{ marginLeft: '5px' }}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </>
                                                        )}
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={this.updateStatus}
                                                            style={{ marginLeft: '10px' }}
                                                        >
                                                            <CheckIcon />
                                                        </Button>
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <div style={{ flex: 1 }}>
                                                        <b>Sub-Tasks:</b>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={this.toggleSubTasksVisibility}
                                                            style={{ left: "10px" }}
                                                        >
                                                            {showSubTasks ? "Hide Sub-Tasks" : "Show Sub-Tasks"}
                                                        </Button>
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <b>Activity Logs:</b>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={this.toggleActivityLogsVisibility}
                                                            style={{ left: '10px' }}
                                                        >
                                                            {this.state.showActivityLogs ? "Hide Activity Logs" : "Show Activity Logs"}
                                                        </Button>
                                                    </div>
                                                </div>
                                                {showSubTasks && selectedTaskDetails.subTasks && selectedTaskDetails.subTasks.length > 0 && (
                                                    <ul style={{ listStyleType: "none", marginTop: "5px", padding: "10px", backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)" }}>
                                                        {selectedTaskDetails.subTasks.map((subTask, index) => (
                                                            <li key={index} style={{ marginBottom: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px" }}>
                                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                                                                    <div>
                                                                        <b>Sub-Task Name:</b> {subTask.name}
                                                                    </div>
                                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                                        <b>Status:</b>
                                                                        {this.state.subTaskEditMode[subTask.name] ? (
                                                                            <>
                                                                                <Select
                                                                                    value={subTask.status}
                                                                                    onChange={(event) => this.handleSubTaskStatusSelect(subTask.name, event.target.value)}
                                                                                    style={{ marginLeft: "10px" }}
                                                                                >
                                                                                    <MenuItem value="Done">Done</MenuItem>
                                                                                    <MenuItem value="Pending">Pending</MenuItem>
                                                                                    <MenuItem value="In Progress">In Progress</MenuItem>
                                                                                    <MenuItem value="Need to Discuss">Need to Discuss</MenuItem>
                                                                                    <MenuItem value="Testing">Testing</MenuItem>
                                                                                </Select>
                                                                                <CheckIcon
                                                                                    onClick={() => {
                                                                                        this.handleSubTaskStatusChange(selectedTaskDetails.id, subTask.name, subTask.status);
                                                                                        this.toggleSubTaskEditMode(subTask.name);
                                                                                    }}
                                                                                    style={{ cursor: "pointer", color: "green", marginLeft: "10px" }}
                                                                                />
                                                                                <CloseIcon
                                                                                    onClick={() => this.toggleSubTaskEditMode(subTask.name)}
                                                                                    style={{ cursor: "pointer", color: "red", marginLeft: "10px" }}
                                                                                />
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <span style={{ marginLeft: "10px" }}>{subTask.status}</span>
                                                                                <EditIcon
                                                                                    onClick={() => this.toggleSubTaskEditMode(subTask.name)}
                                                                                    style={{ cursor: "pointer", color: "#1b6e95", marginLeft: "10px" }}
                                                                                />
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <b>Details:</b>
                                                                    <div dangerouslySetInnerHTML={{ __html: subTask.details }} style={{ marginTop: "5px", padding: "10px", backgroundColor: "#f0f0f0", borderRadius: "8px" }} />
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                                {this.state.showActivityLogs && (
                                                    <div style={{ marginTop: "5px", padding: "10px", backgroundColor: "#fff", borderRadius: "8px", boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)" }}>
                                                        {Array.isArray(this.state.activityLogs) && this.state.activityLogs.length > 0 ? (
                                                            <div style={{ padding: 0 }}>
                                                                {this.state.activityLogs.map((log, index) => (
                                                                    <div key={index} style={{ marginBottom: "10px", padding: "10px", border: "1px solid #ddd", borderRadius: "8px", position: "relative", paddingRight: "120px" }}>
                                                                        <div>
                                                                            {index + 1}. {log.description}
                                                                        </div>
                                                                        <div style={{ fontSize: "0.9em", color: "gray", position: "absolute", bottom: "5px", right: "10px", whiteSpace: "nowrap" }}>
                                                                            {log.timestamp}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <p>No activity logs available.</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </DialogContent>
                                    </div>
                                </Dialog>
                            )}
                        </div>
                    } />
                <Footer {...this.props} />
            </div>
        );
    }
}

export default Taskslist;